
import React, { useEffect } from "react";
import { Spinner } from "@sapphire-react/lab";
import * as styles from './PreLogonComponent.style';
import { createUrl } from "../../api/ApiCalls";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Variables } from "../../api/utils/endpoints";

const PreLogonComponent = () => {
    //getting the language paramter in the url
    var { language } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const allowedLanguages = Variables.allowedLanguageArray;
    const defaultLanguage = Variables.finnishLanguageCode;

    //fetching the ticketID from the query parameter
    const searchParams = new URLSearchParams(location.search);
    const ticketID = searchParams.get(Variables.TicketIDQueryParameter);
    useEffect(() => {
        //If no ticketID is provided, go to the Error screen
        if (!ticketID) {
            console.log("No TicketID provided in the query");
            navigate(`/${language}/signin/error`, { replace: true })
            return;
        }
        //If no language or any other language is given, go to the default language
        if (!language || !allowedLanguages.includes(language)) {
            navigate(`/${defaultLanguage}/signin${location.search}`, { replace: true });
            return;
        }
        else {
            //go to the createUrl function to get the AuthMS login url to start the logon
            var redirectUrl = createUrl(language as string, ticketID);
            window.location.replace(redirectUrl);
        }
    }, [ticketID, language, navigate, location.search, allowedLanguages, defaultLanguage]);

    return (
        <div style={styles.mainDiv}>
            <Spinner aria-label="Loading..." size="xl" margin="auto" />
        </div>
    );
};


export default PreLogonComponent;